import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ReactTable from "react-table";
import {array} from "prop-types";

export default class RegionalPhoneLogs extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Phone_Logs_Regions._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	formatData = async (data) => {
		return data.rows.reduce((end = {pages: data.pages, rows: []}, currentCall) =>  {
			end.rows.some(c => c.region === currentCall.region)
				? (function() {
					let region = end.rows.find(c => c.region === currentCall.region);
					region.total += region[setCallPropName(currentCall.call_type)] = +currentCall.count; //Yes, this works. JS is AMAZING (or horrifying).
				})()
				: (function() {
					let newRegion = {
						region: currentCall.region,
						name: currentCall.regions.name,
						total: +currentCall.count
					};
					newRegion[setCallPropName(currentCall.call_type)] = +currentCall.count;
					end.rows.push(newRegion);
				})();
			return end;
		}, {pages: data.pages, rows: []});
		//Note: This was complicated a little bit by the need to have the result in an object format with properties 'pages' and 'rows'
		//Could be mitigated by changing Collections.js in react.framework, line 555 to `res.rows = await this.formatData(res.rows);`
		//In which case, end would return to having `[]` as its initial value, and there wouldn't be references to end.rows within the callback

		function setCallPropName(pkey) {
			switch(pkey){
				case 1: return 'booked_new';
				case 2: return 'booked_existing';
				case 3: return 'too_expensive';
				case 4: return 'too_far_out';
				case 5: return 'client_call';
				case 6: return 'client_cancellation';
				case 7: return 'client_reschedule';
				case 8: return 'client_revisit';
				case 9: return 'price_shopping';
				case 10: return 'spam';
				case 11: return 'wrong_company';
				default: return console.error('pkey not defined in setCallPropName (RegionalPhoneLogs.js, line 51)');
			}
		}
	}

	render(){
		const {data, pages, limit, loading} = this.state;
		const displayData = key => obj => obj.hasOwnProperty(key)
			? `${+obj[key]} / ${((+obj[key]/+obj.total)*100).toFixed(2)}%`
			: '0 / 0.00%';
		this.state.limit = null
		const columns = [
			{
				Header: 'Region',
				accessor: 'name',
				id: "regions.name"
			},
			{
				Header: 'Total Calls',
				accessor: 'total'
			},
			{
				Header: 'Booked New',
				id: 'booked_new',
				accessor: displayData('booked_new')
			},
			{
				Header: 'Booked Existing',
				id: 'booked_existing',
				accessor: displayData('booked_existing')
			},
			{
				Header: 'Too Expensive',
				id: 'too_expensive',
				accessor: displayData('too_expensive')
			},
			{
				Header: 'Too Far Out',
				id: 'too_far_out',
				accessor: displayData('too_far_out')
			},
			{
				Header: 'Client Call',
				id: 'client_call',
				accessor: displayData('client_call')
			},
			{
				Header: 'Client Cancellation',
				id: 'client_cancellation',
				accessor: displayData('client_cancellation')
			},
			{
				Header: 'Client Reschedule',
				id: 'client_reschedule',
				accessor: displayData('client_reschedule')
			},
			{
				Header: 'Client Revisit',
				id: 'client_revisit',
				accessor: displayData('client_revisit')
			},
			{
				Header: 'Price Shopping',
				id: 'price_shopping',
				accessor: displayData('price_shopping')
			},
			{
				Header: 'Spam',
				id: 'spam',
				accessor: displayData('spam')
			},
			{
				Header: 'Wrong Company',
				id: 'wrong_company',
				accessor: displayData('wrong_company')
			}
		];



		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Logs')}
							{this.renderDateRangeSearch()}
							{this.renderHeaderRight("Log",columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
